import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import 'url-search-params-polyfill'

let debug = process.env.NODE_ENV !== 'production'
// debug = false // DEBUG

let urlParams = new window.URLSearchParams(window.location.search)
if (urlParams.get('_debug') !== null) debug = true

const state = {

  debug: debug,

  // LOADING
  loading: {
    progress: 0,
    completed: false
  },

  // GAMEPLAY
  gameState: null,

  // RESULTS
  ranking: {
    position: null,
    total: null,
    percentile: null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}





// WEBPACK FOOTER //
// ./src/store/game/index.js